import { CancellationFeedback } from './CancellationFeedback';

export const CancellationFeedbackManager = () => <CancellationFeedback />;
